import { Dispatch, bindActionCreators } from "redux";
import React, { Fragment } from "react";

import AdesaoActions from "../../store/ducks/adesao";
import MenuAside from "../../components/MenuAside";
import Progresso from "../../components/Progresso";
import RealizePrev from "../../support";
import { RootState } from "../../store/ducks";
import Titulo from "../../components/Titulo";
import { connect } from "react-redux";
import translate from "../../i18n";

interface Props {
  adesao?: {
    registros: {
      dadosAdesao: {
        nome: string;
        nomeSocial?: string;
        email?: string;
      };
      dadosAssinatura?: {
        idDocumentoFornecedor: string;
      };
    };
  };
}
const Parabens: React.FC<Props> = ({ adesao }) => {
  //Disponibiliza botão de assinatura
  const getLinkAssinatura = () => {
    var h = window.innerHeight;
    var w = window.innerWidth;
    var idDocumento = adesao?.registros.dadosAssinatura?.idDocumentoFornecedor;
    window.open(
      RealizePrev().PowerForm +
        idDocumento +
        "&se=" +
        adesao?.registros.dadosAdesao.email,
      //"rafaelbessa2@gmail.com",
      "_blank",
      "toolbar=no ,location=0,status=no,titlebar=no,menubar=no,width=" +
        w +
        ",height=" +
        h
    );
  };

  return (
    <Fragment>
      <div className="content wrapper">
        <MenuAside step={5} />

        <div className="container">
          <h2>{translate.t("app.tela.parabens.titulo")} </h2>

          <div className="pb-4  mb-4 mt-4">
            <div className="row  align-items-center">
              <div className="col-lg-8 offset-lg-2">
                <p>
                  <big>
                    <strong>
                      Parabéns{" "}
                      {adesao?.registros?.dadosAdesao?.nomeSocial
                        ? adesao?.registros?.dadosAdesao?.nomeSocial
                        : adesao?.registros?.dadosAdesao?.nome}
                      !
                    </strong>
                  </big>
                </p>
                <p>
                  <big>
                    {translate.t(
                      "app.tela.parabens.label.tituloConclusao.parte1"
                    )}
                  </big>
                </p>
                <p>
                  <big>
                    {translate.t(
                      "app.tela.parabens.label.tituloConclusao.parte2"
                    )}
                  </big>
                </p>
                <p>
                  <big>
                    {translate.t(
                      "app.tela.parabens.label.tituloConclusao.parte3"
                    )}
                  </big>
                </p>
                <p>
                  <big>
                    <div>
                      <a
                        onClick={getLinkAssinatura}
                        href="#"
                        className="btn btn--primary mt-lg-4"
                      >
                        ASSINAR ELETRONICAMENTE
                      </a>
                    </div>
                  </big>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  adesao: state.adesao,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(AdesaoActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Parabens);
